import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getOrganizationsFromBackend, pickOrganization } from '../api';

const OrgIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 4h5m-5 4h5" /></svg>
);

const ArrowIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
);

function OrganizationPage() {
    const [organizations, setOrganizations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const location = useLocation();

    // Simpan token dari URL ke localStorage jika ada
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get("token");
        if (token) {
            localStorage.setItem("token", token);
            // Hapus token dari URL agar tidak dikirim ulang saat reload
            navigate("/select-organization", { replace: true });
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) {
            navigate("/login", { replace: true });
            return;
        }
        setLoading(true);
        getOrganizationsFromBackend()
            .then((data) => {
                setOrganizations(data);
                setError('');
            })
            .catch((err) => {
                setError(err.message || 'Gagal memuat organisasi');
            })
            .finally(() => setLoading(false));
    }, [navigate]);

    const handleSelect = async (org) => {
        await pickOrganization(org.organization_id, org.nama_organization);
        navigate('/dashboard');
    };

    return (
        <div className="bg-gray-100 flex items-center justify-center min-h-screen py-10">
            <div className="w-full max-w-md p-8 text-center">
                <h1 className="text-3xl font-bold text-gray-800">Pilih Organisasi</h1>
                <p className="text-gray-500 mt-2 mb-10">Silakan pilih organisasi yang ingin Anda kelola.</p>
                {loading ? (
                    <div className="text-gray-500">Memuat organisasi...</div>
                ) : error ? (
                    <div className="text-red-500">{error}</div>
                ) : organizations.length === 0 ? (
                    <div className="text-gray-500">Tidak ada organisasi untuk akun ini.</div>
                ) : (
                    <div className="space-y-4 text-left">
                        {organizations.map((org) => (
                            <button
                                key={org.organization_id}
                                onClick={() => handleSelect(org)}
                                className="flex items-center justify-between w-full p-5 bg-white rounded-xl shadow-sm hover:shadow-md hover:bg-gray-50 transition-all duration-300 cursor-pointer"
                            >
                                <div className="flex items-center">
                                    <div className="p-2 bg-gray-100 rounded-lg mr-4"><OrgIcon /></div>
                                    <div>
                                        <p className="font-bold text-gray-800">{org.nama_organization}</p>
                                        <p className="text-sm text-gray-400">ID: {org.organization_id}</p>
                                    </div>
                                </div>
                                <ArrowIcon />
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default OrganizationPage;